import { Component, inject } from '@angular/core';
import { ModalRef } from '../../modal/modal-ref';
import { ModalConfig } from '../../modal/modal-config';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { NgForm, FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { resizeImage } from '../../image-resize.util';
import { StorageImage } from '../../storage-images.util';
import { StorageImageService } from '../../storage-image.service';
import { ImagePickerComponent } from '../../image-picker/image-picker.component';

@Component({
  selector: 'app-blogpost',
  templateUrl: './blogpost.component.html',
  styleUrls: ['./blogpost.component.scss'],
  imports: [FormsModule, QuillModule, ImagePickerComponent]
})
export class BlogpostComponent {
  private modal = inject(ModalRef);
  config = inject(ModalConfig);
  private storage = inject(AngularFireStorage);
  private storageImages = inject(StorageImageService);

  public inputData;
  image;
  uploadedImage: File;
  images: StorageImage[] = [];
  public formData = {
    title: '', date: '', summary: '', content: '', image: '', bg: '',
    fileLink: '', imageIsFile: true, picture_text: '', gallery: false, order: 0
  };

  private id;

  constructor() {
    this.inputData = this.config.data;
    this.image = this.inputData.content?.attributes?.image ?? '';
    this.getSavedImages();
    if (this.inputData.content?.id) {
      this.formData = this.inputData.content.attributes;
      this.id = this.inputData.content.id;
    }
  }

  addImage(event) {
    const file = event.target.files[0];
    const filePath = 'user-images/' + file.name;

    resizeImage(file, 720, 500).then(resized => {
      this.uploadedImage = resized;
      this.storage.upload(filePath, this.uploadedImage).then(() => {
        this.getSavedImages();
        this.image = filePath;
      });
    });
  }

  onAddArticle(formData: NgForm) {
    const formAttributes = formData.form.value;
    formAttributes.image = this.image;
    formAttributes.gallery = false;
    const data = {type: this.inputData.type, attributes: formAttributes, id: this.id};
    this.modal.close(data);
  }

  getSavedImages() {
    this.storageImages.listSavedImages().then(images => {
      this.images = images;
    }).catch(error => console.log(error));
  }

  selectImage(imagePath: string) {
    this.image = imagePath;
  }

  onImageDeleted(img: StorageImage) {
    if (this.image === img.path) {
      this.image = '';
    }
    this.getSavedImages();
  }
}
